

// Emojis
import AngryFace from "../Icons/components/emojis/AngryFace";
import SadFace from "../Icons/components/emojis/SadFace";
import StraightFace from "../Icons/components/emojis/StraightFace";
import HappyFace from "../Icons/components/emojis/HappyFace";
import StarstruckFace from "../Icons/components/emojis/StarstruckFace";

export let Steps;(function (Steps) {Steps["Emoji"] = "Emoji";Steps["Reason"] = "Reason";Steps["Conclusion"] = "Conclusion";})(Steps || (Steps = {}));





export let Feedback;(function (Feedback) {Feedback["Horrible"] = "Horrible";Feedback["Bad"] = "Bad";Feedback["Okay"] = "Okay";Feedback["Great"] = "Great";Feedback["Awesome"] = "Awesome";})(Feedback || (Feedback = {}));







export const feedbackIconMap =


{
  [Feedback.Horrible]: AngryFace,
  [Feedback.Bad]: SadFace,
  [Feedback.Okay]: StraightFace,
  [Feedback.Great]: HappyFace,
  [Feedback.Awesome]: StarstruckFace };